import ctu from './ctu';
import iso from './iso';
import kaplan from './kaplan';

export default [ctu, kaplan, iso];
